import './ReferralCompanyDetails.scss'
import React, {Component} from 'react'
import { Button, Image } from 'react-bootstrap'
import { convertNewlinesToBreaks, numberToCurrency } from 'common/util/helper'
import { DIGITAL_LENDER_PROVIDERS, DIGITAL_LOAN_TYPES } from 'common/constants'

import {
  deleteOptOut
} from 'manager/redux/referral_opt_out'

class ReferralCompanyDetails extends Component {

  constructor(props) {
    super(props)
  }

  handleSubmit() {
    if (this.props.onSubmit) {
      this.props.onSubmit()
    } else {
      this.props.dispatch(deleteOptOut(this.props.params.hash, this.props.type))
    }
  }

  render() {
    const {
      digitalLender,
      description,
      officer,
      officerEmail,
      officerPhone,
      officerPhoneFormatted,
      referral,
      shortUrl,
      type,
      url
    } = this.props

    if (!referral) {
      return null
    }

    const isLoan = type === "loan"

    const {
      digital_lender_key,
      is_preapproved,
      loan_broker_phone,
      loan_broker_email,
      loan_relation_manager_name,
      loan_relation_manager_email,
      loan_relation_manager_phone,
      loan_type,
      settlement_broker_phone,
      settlement_broker_email,
      pre_approval_amount
    } = referral

    const brokerPhone = isLoan ? loan_broker_phone : settlement_broker_phone
    const brokerEmail = isLoan ? loan_broker_email : settlement_broker_email

    let financingStatus
    if (digitalLender) {
      if (is_preapproved) {
        financingStatus = "Pre-approved"
        if (Number.isFinite(pre_approval_amount)) {
          financingStatus = `${financingStatus} for up to ${numberToCurrency(pre_approval_amount)}`
        }
      } else {
        financingStatus = "Not pre-approved"
      }
    }

    return (
      <div>
        <div className="ReferralCompanyDetails">
          <div className="ReferralCompanyDetails__section ReferralCompanyDetails__header">
            {
              this.props.logoPath ? <Image src={this.props.logoPath} className="ReferralCompanyDetails__logo"/> : null
            }
            <div className="ReferralCompanyDetails__branding">
              <div className="ReferralCompanyDetails__header_title">{digitalLender ? "" : "Opcity "}Network {this.props.networkLabel}</div>
              <div className="ReferralCompanyDetails__company">{this.props.profileName ? this.props.profileName : this.props.company}</div>
            </div>
          </div>
          {digitalLender && (
            <div className="ReferralCompanyDetails__section">
              <div className="ReferralCompanyDetails__title">Financing</div>
              <div className="ReferralCompanyDetails__grid">
                <div className="ReferralCompanyDetails__row">
                  <div className="ReferralCompanyDetails__label">Status</div>
                  <div className="ReferralCompanyDetails__value">
                    {financingStatus}
                  </div>
                </div>
                {is_preapproved && (
                  <div className="ReferralCompanyDetails__row">
                    <div className="ReferralCompanyDetails__label">Notes</div>
                    <div className="ReferralCompanyDetails__value">
                      <i className="fa fa-check-circle ReferralCompanyDetails__icon ReferralCompanyDetails__check" />Credit verified
                    </div>
                  </div>
                )}
                {DIGITAL_LOAN_TYPES[loan_type] && (
                  <div className="ReferralCompanyDetails__row">
                    <div className="ReferralCompanyDetails__label">Loan Program</div>
                    <div className="ReferralCompanyDetails__value">
                      {DIGITAL_LOAN_TYPES[loan_type].label} Loan
                    </div>
                    <p className="ReferralCompanyDetails__description">{DIGITAL_LOAN_TYPES[loan_type].description}</p>
                  </div>
                )}
              </div>
              {is_preapproved && digital_lender_key === DIGITAL_LENDER_PROVIDERS.ROCKET_MORTGAGE && (
                <div>
                  <hr className="ReferralCompanyDetails__hr" />
                  <a className="ReferralCompanyDetails__link" href="https://www.rocketpro.com/" rel="noopener noreferrer" target="_blank">
                    <i className="fa fa-external-link ReferralCompanyDetails__icon" />Customize Pre-approval Letter with Rocket Pro℠ Insights
                  </a>
                </div>
              )}
            </div>
          )}
          <div className="ReferralCompanyDetails__section">
            <div className="ReferralCompanyDetails__title">{this.props.companyLabel} Contact</div>
            <div className="ReferralCompanyDetails__grid">
              {(officer || officerEmail || officerPhoneFormatted) && (
                <div className="ReferralCompanyDetails__contact_section">
                  <div className="ReferralCompanyDetails__subtitle">{this.props.officerLabel} Officer</div>
                  {officer && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Officer</div>
                      <div className="ReferralCompanyDetails__contact_value"><i className="fa fa-user ReferralCompanyDetails__icon" />{ officer }</div>
                    </div>
                  )}
                  {officerEmail && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Email</div>
                      <div className="ReferralCompanyDetails__contact_value"><a className="ReferralCompanyDetails__link" href={"mailto:" + officerEmail}><i className="fa fa-envelope ReferralCompanyDetails__icon" />{ officerEmail }</a></div>
                    </div>
                  )}
                  {officerPhone && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Phone</div>
                      <div className="ReferralCompanyDetails__contact_value"><a className="ReferralCompanyDetails__link" href={"tel:" + officerPhone}><i className="fa fa-phone ReferralCompanyDetails__icon" />{ officerPhoneFormatted }</a></div>
                    </div>
                  )}
                </div>
              )}
              {isLoan && (loan_relation_manager_name || loan_relation_manager_email || loan_relation_manager_phone) && (
                <div className="ReferralCompanyDetails__contact_section">
                  <div className="ReferralCompanyDetails__subtitle">Relationship Manager</div>
                  {loan_relation_manager_name && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Manager</div>
                      <div className="ReferralCompanyDetails__contact_value"><i className="fa fa-user ReferralCompanyDetails__icon" />{ loan_relation_manager_name }</div>
                    </div>
                  )}
                  {loan_relation_manager_email && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Email</div>
                      <div className="ReferralCompanyDetails__contact_value"><a href={"mailto:" + loan_relation_manager_email}><i className="fa fa-envelope ReferralCompanyDetails__icon" />{ loan_relation_manager_email }</a></div>
                    </div>
                  )}
                  {loan_relation_manager_phone && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Phone</div>
                      <div className="ReferralCompanyDetails__contact_value"><a href={"tel:" + loan_relation_manager_phone}><i className="fa fa-phone ReferralCompanyDetails__icon" />{ loan_relation_manager_phone }</a></div>
                    </div>
                  )}
                </div>
              )}
              {(brokerPhone || brokerEmail || url || description) && (
                <div className="ReferralCompanyDetails__contact_section">
                  <div className="ReferralCompanyDetails__subtitle">Company</div>
                  {brokerPhone && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Phone</div>
                      <div className="ReferralCompanyDetails__contact_value"><a className="ReferralCompanyDetails__link" href={"tel:" + brokerPhone}><i className="fa fa-phone ReferralCompanyDetails__icon" />{ brokerPhone }</a></div>
                    </div>
                  )}
                  {brokerEmail && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Email</div>
                      <div className="ReferralCompanyDetails__contact_value"><a className="ReferralCompanyDetails__link" href={"mailto:" + brokerEmail}><i className="fa fa-envelope ReferralCompanyDetails__icon" />{ brokerEmail }</a></div>
                    </div>
                  )}
                  {url && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label ReferralCompanyDetails__label--hidden">Website</div>
                      <div className="ReferralCompanyDetails__contact_value"><a className="ReferralCompanyDetails__link" href={this.props.url}><i className="fa fa-external-link ReferralCompanyDetails__icon" />{ shortUrl ? shortUrl : url }</a></div>
                    </div>
                  )}
                  {description && (
                    <div className="ReferralCompanyDetails__contact_row">
                      <div className="ReferralCompanyDetails__label">Company Info</div>
                      <div className="ReferralCompanyDetails__contact_value" dangerouslySetInnerHTML={{__html: convertNewlinesToBreaks(description)}}/>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="ReferralCompanyDetails__button_wrapper">
            <Button onClick={() => this.handleSubmit()} bsStyle="info">Use This Network {this.props.networkLabel}</Button>
          </div>
        </div>
        <div className="DisclaimerFooter">
          <div className="DisclaimerFooter__text">Realtor.com® does not endorse or promote this {this.props.disclosureLabel} service provider and any and all service descriptions were provided by the {this.props.disclosureLabel} service provider directly.
          You’re encouraged to shop around to determine if you’re receiving the best rate and services for your particular needs.</div>
        </div>
      </div>
    )
  }
}

export default ReferralCompanyDetails
